import React from 'react';
import { TableCellProps } from '../../../types/search';

const PortalCellReferenceId: React.FC<TableCellProps> = ({ value, row, listingType }) => {
  return (
    <div className={`portal-cell portal-cell--${listingType} portal-cell--reference-id`}>
      <p className="portal-cell__bold-underline-text">{value}</p>
    </div>
  );
};

export default PortalCellReferenceId;
